<template>
  <td class="app-cell">
    <div class="app-inner">
      <div class="icon-block">
        <img class="app-icon" :src="info.appIcon">
      </div>
      <div class="main-block">
        <div class="name-block">
          <div class="app-name-container"><a :href="info.appUrl" class="app-link" target="_blank">{{ info.appName }}</a></div>
          <div class="company-name-container"><a :href="info.appPublisherUrl" class="company-link" target="_blank">{{ info.appPublisher }}</a></div>
        </div>
        <div class="rank-block" >
          <span v-if="info.isNew" class="super-up"></span>
          <span v-else-if="info.delta === 0" >=</span>
          <span v-else-if="info.delta > 0" class="change-up">▲ {{ info.delta }}</span>
          <span v-else-if="info.delta < 0" class="change-down">▼ {{ Math.abs(info.delta) }}</span>
        </div>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  name: 'AppInfo',
  props: ['info'],
}
</script>

<style scoped>
.app-cell {
  border: 1px solid #ccc;
  border-spacing: 0;
  width: 300px;
  max-width: 300px;
}

.app-inner {
  padding: 10px 16px 7px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: url(../assets/img/iap.png) no-repeat;
  background-size: 15px;
  align-items: center;
}

.icon-block {
  min-width: 34px;
  height: 34px;
  margin-right: 10px;
}

.app-icon {
  height: 34px;
}

.main-block {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  overflow: hidden;
}

.name-block {
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}

.app-name-container{
  height: 23px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.company-name-container {
  height: 19px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.app-link {
  color: #102235;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-decoration: none;
}

.company-link {
  color: #999;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-decoration: none;
}

.name-block a:hover {
  text-decoration: underline;
}

.rank-block {
  min-width: 40px;
  text-align: center;
  padding: 16px 0;
}

.super-up {
  background-image: url(https://static.garena.tw/download/metrics.garena.tw/2025-12-24/L972rBR9SVyCjnlN1mFASA.png?key=nOte5);
  background-position: -3px -1040px;
  width: 10px;
  height: 16px;
  display: inline-block;
}

.change-up {
  color: #6a6;
}

.change-down {
  color: #a66;
}

.iap-block {
  position: absolute;
  top: -8px;
  left: -8px;
  width: 20px;
  height: 20px;
  background: #fff;
  color: #51a250;
  border: 1px solid #51a250;
  border-radius: 100%;
}

.iap-info {
  padding: 1px 3px 0;
  font-size: 8px;
  font-style: normal;
  line-height: 9px;
  background: #fff;
  color: #51a250;
  font-family: Helvetica,'ProximaNova-Regular',Helvetica,Arial,sans-serif;
  position: absolute;
  right: 1px;
  bottom: 1px;
  border: none;
  background: transparent;
}
</style>
